import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(
  '997addc8bfa84d096d67e186bc5fc565Tz0xMzM4NjcsRT0xODI0Mzc5MjAwMDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9c2luZ2xlLEtWPTI='
)

export const MuiXLicense = () => {
  return null
}
